import { ElementType, useCallback } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'

import { ToggleSidebar } from '@authy/lib-web/components'

import { Header } from './Header'
import { Menu } from './Menu'
import { User } from './User'
import { Canvas } from './Canvas'

type SidebarProps = {
    Header?: ElementType
    Canvas?: ElementType
    open: boolean
    onToggleOpen: () => void
    collapsed: boolean
    onToggleCollapsed: () => void
}

export const Sidebar = observer(
    ({
        Header: HeaderComponent,
        Canvas: CanvasComponent,
        open,
        onToggleOpen,
        collapsed,
        onToggleCollapsed,
    }: SidebarProps) => {
        const handleActivate = useCallback(() => {
            onToggleOpen()
        }, [onToggleOpen])

        return (
            <div className={classNames('group relative hidden h-full flex-col md:flex', { '!flex': open })}>
                <Header collapsed={collapsed} onActivate={handleActivate}>
                    {HeaderComponent && <HeaderComponent collapsed={collapsed} />}
                </Header>
                <Menu collapsed={collapsed} onActivate={handleActivate} />
                <Canvas collapsed={collapsed}>{CanvasComponent && <CanvasComponent collapsed={collapsed} />}</Canvas>
                <User collapsed={collapsed} onActivate={handleActivate} />
                <ToggleSidebar side="left" collapsedVariant="hide" collapsed={collapsed} onToggle={onToggleCollapsed} />
            </div>
        )
    }
)
